import { createReducer, on } from "@ngrx/store";
import * as PupilLinkActions from './pupil-link.actions';
import { initialPupilLinkState } from "./pupil-link.state";

export const pupilLinkReducer = createReducer(
  initialPupilLinkState,

  // LOAD
  on(PupilLinkActions.loadMismatches, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PupilLinkActions.loadMismatchesSuccess, (state, { mismatches }) => ({
    ...state,
    loading: false,
    mismatches,
  })),
  on(PupilLinkActions.loadMismatchesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // RESOLVE / CREATE / DISMISS: the handled request leaves the list on success.
  on(PupilLinkActions.resolveMismatch, (state, { request }) => ({
    ...state,
    actionInProgressId: request.mismatchId,
    error: null,
  })),
  on(PupilLinkActions.createPupil, PupilLinkActions.dismissMismatch, (state, { mismatchId }) => ({
    ...state,
    actionInProgressId: mismatchId,
    error: null,
  })),
  on(
    PupilLinkActions.resolveMismatchSuccess,
    PupilLinkActions.createPupilSuccess,
    PupilLinkActions.dismissMismatchSuccess,
    (state, { mismatchId }) => ({
      ...state,
      actionInProgressId: null,
      mismatches: state.mismatches.filter((m) => m.id !== mismatchId),
    })
  ),
  // Action failures are shown in a snackbar by the page, so they do not set the persistent error banner.
  on(
    PupilLinkActions.resolveMismatchFailure,
    PupilLinkActions.createPupilFailure,
    PupilLinkActions.dismissMismatchFailure,
    (state) => ({
      ...state,
      actionInProgressId: null,
    })
  )
);
